import type { StaticCataloguesCatalogueDto } from '@ori/static-api-client-react';
import { useGetTenantCatalogues } from '@ori/static-api-client-react';
import type { FC, PropsWithChildren } from 'react';
import { createContext, useContext, useMemo } from 'react';

import { useAppConfig } from './configurationContext';

export interface CataloguesContext {
  catalogues: StaticCataloguesCatalogueDto[];
  isLoading: boolean;
}

export const cataloguesContextDefaultValue: CataloguesContext = {
  catalogues: [],
  isLoading: false,
};

export const cataloguesContext = createContext(cataloguesContextDefaultValue);

const { Provider } = cataloguesContext;

export const CataloguesProvider: FC<PropsWithChildren> = ({ children }) => {
  const { tenant } = useAppConfig();
  const { data, error } = useGetTenantCatalogues(tenant, undefined, {
    swr: {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  });

  const value = useMemo(
    () => ({ catalogues: data?.collection ?? [], isLoading: data === undefined && error === undefined }),
    [data, error],
  );

  return <Provider value={value}>{children}</Provider>;
};

export const useCatalogues = () => useContext(cataloguesContext);
